import _ from 'underscore';

import * as StepConstants from 'notebook/protocols/StepConstants';
import TableUtil from 'notebook/tables/TableUtil';

export function protocolSpreadsheetComponentWillReceiveProps(props, nextProps, setMultiEditingForTable) {
  // This allows us to push custom metadataForRestore to a child
  // if desired (ie on table insert). Custom state will be overwritten
  // if our parent pushes new props (ie undo, redo)
  if (nextProps.metadataForRestore !== props.metadataForRestore) {
    const metadata = nextProps.metadataForRestore;
    // If any of the tables are to restore state, update the multi-editing state.
    const tableSteps = _.where(props.spreadsheetRoot(nextProps), {level: StepConstants.StepLevel.TABLE});
    // eslint-disable-next-line no-unreachable-loop
    for (const step of Array.from(tableSteps)) {
      const tableKey = TableUtil.getTableMultiSelectKey(step.cid);
      if (metadata != null && tableKey === metadata.multiSelectKey) {
        const multiState = metadata.data;
        const index = multiState.multiSelIndex;
        // multiSelIndex can be out of bounds, if the user had the selection in a "ghost cell"
        let text = null;
        if (index != null) {
          const cell = step.table.table[index[0]] != null ? step.table.table[index[0]][index[1]] : undefined;
          // eslint-disable-next-line benchlint/no-eqeqeq-null
          if (typeof cell !== 'undefined' && cell !== null) {
            text = cell.text;
          }
        }
        setMultiEditingForTable(step.table.name, {
          index,
          editing: false,
          text,
        });
      }
      break;
    }
  }
}
